import React from "react";

import useSiteContext from "@brexhq/next/src/hooks/useSiteContext";
import { checkInternalLink } from "@brexhq/next/src/utils/links";

interface _CoreLinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  to: string;
  prefetch?: boolean;
}

// TODO investigate why this causes a problem
export type CoreLinkProps = Omit<_CoreLinkProps, "aria-relevant">;

/**
 * This is a wrapper around a Gatsby or Next.js link that handles switching between a regular anchor tag and the framework specific link. No need to ever use this directly.
 * @param props - CoreLinkProps
 */
export const CoreLink = React.forwardRef<HTMLAnchorElement, CoreLinkProps>(
  function CoreLinkComponent(
    // Ignoring this because we want to extract style from defaultProps
    // eslint-disable-next-line
    { to, children, style, prefetch, ...defaultProps },
    ref,
  ) {
    const { isInternalLink, link } = checkInternalLink(to);
    const withoutModuleTheme = {
      ...defaultProps,
      moduleTheme: undefined,
      pointDown: undefined,
      isFullWidth: undefined,
    };
    delete withoutModuleTheme.moduleTheme;
    delete withoutModuleTheme.pointDown;
    delete withoutModuleTheme.isFullWidth;

    const { navigators } = useSiteContext();

    const LinkComponent = navigators.component;

    const linkProps = {
      href: link,
      "data-testid": "rebirth-link",
      ...withoutModuleTheme,
    };

    if (isInternalLink && !link.includes("#")) {
      return (
        <LinkComponent {...linkProps} ref={ref} prefetch={prefetch}>
          {children}
        </LinkComponent>
      );
    }

    return (
      <a
        ref={ref}
        rel={defaultProps?.rel}
        href={linkProps.href}
        data-testid="rebirth-link"
        {...withoutModuleTheme}
      >
        {children}
      </a>
    );
  },
);
